import { OptionType } from '@interfaces/OptionType'
import { SortEnum } from '@interfaces/SortEnum'

export const sortOptions: OptionType[] = [
  { label: 'Ascending', value: SortEnum.ASCENDING },
  { label: 'Descending', value: SortEnum.DESCENDING },
]
